export const teamColors = {
  'Any team': { bg: '#000000', color: '#ffffff' },
  'Williams': { bg: '#00A0DE', color: '#ffffff' }, // darker light blue background with white font
  'Ferrari': { bg: '#FF0000', color: '#ffffff' }, // red background with white font
  'Red Bull': { bg: '#000080', color: '#ffffff' }, // navy background with white font
  'Haas': { bg: '#ffffff', color: '#FF0000' }, // white background with red font
  'Aston Martin': { bg: '#006400', color: '#ffffff' }, // green background with white font
  'Alpine': { bg: '#0066CC', color: '#ffffff' }, // middle blue white font
  'Kick Sauber': { bg: '#000000', color: '#FFFF00' }, // black background with yellow font
  'McLaren': { bg: '#FFA500', color: '#000000' }, // orange background with black font
  'Racing Bulls': { bg: '#4169E1', color: '#ffffff' }, // royal blue background with white font
  'Mercedes': { bg: '#C0C0C0', color: '#000000' }, // silver background with black font
}; 